<nz-modal nzDraggable nzCentered [(nzVisible)]="showModal" [nzTitle]="title" [nzOkText]="isOkText"
  [nzCancelText]="cancelText" (nzOnOk)="handleOk()" (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <ng-content></ng-content>
  </ng-container>
</nz-modal>